import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export function useHashHighlight(ready) {
  const { hash } = useLocation();
  const key = hash.startsWith("#ind-") ? hash.slice(5) : null;
  const [active, setActive] = useState(key);
  useEffect(() => {
    if (!ready || !key) return;
    setActive(key);
    const t = setTimeout(() => document.getElementById(`ind-${key}`)?.scrollIntoView({ behavior: "smooth", block: "center" }), 150);
    const off = setTimeout(() => setActive(null), 3500);
    return () => { clearTimeout(t); clearTimeout(off); };
  }, [ready, key]);
  return active;
}
